export const environment = {
    production: true,
    baseUrl: 'https://api.genailia.com',
    baseUrlOther: 'https://api.genailia.com/api/v2',
    keycloak: {
        authority: 'https://login.genailia.com/',
        refreshAuthority: 'https://login.genailia.com/realms/genzers/protocol/openid-connect/token',
        redirectUri: 'https://app.genailia.com/home',
        postLogoutRedirectUri: 'https://app.genailia.com/home',
        postLogoutRedirectLogoutUri: 'https://app.genailia.com/logout',
        realm: 'genzers',
        clientId: 'genailia',
    },
    idleConfig: { idle: 10, timeout: 60, ping: 10 },
    blockConsoleMessages: false
};
